import { fetch } from '../../utils';
import Backend from '../../backend';
import store from '../../store';
import { trackMissionProgress } from '../missionAndReward/duck';

export const trackMissionRequirementApi = async (type, detail) => {
  const missionAndEventMapping = store.getState().missionAndReward.missionAndEventMapping || {};
  const targetEvent =  detail? `${type}.${detail}` : type;
  const targetContentSources = missionAndEventMapping?.[targetEvent]||[];
  const generalSources = missionAndEventMapping?.[type]||[];
  const sources = Array.from(new Set([...targetContentSources, ...generalSources]));
  
  if(sources && sources.length > 0){
    store.dispatch(
      trackMissionProgress({
        sources,
        value: 1,
        action: type
      })
    );
    return true;
  }
  return false;

}

export async function trackDirect(type, detail) {


  try {
    trackMissionRequirementApi(type, detail);
    return await fetch(Backend.methodUrl('track'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ type, detail })
    });
  } catch (error) {
    console.log(error);
  }
}

export async function trackDirectAnonymous(adviserId, type, detail) {
  try {
    return await fetch(Backend.methodUrl('trackAnonymous'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ adviserId, type, detail })
    });
  } catch (error) {
    console.log(error);
  }
}
